// src/components/common/PageFade.jsx
import React from "react";

const PageFade = ({ children }) => {
  return (
    <div className="animate-fadeIn">
      {children}
    </div>
  );
};

export default PageFade;
